import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const mergeTailwindClassNames = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        "heading-xxlarge",
        "heading-xlarge",
        "heading-large",
        "heading-medium",
        "heading-small",
        "heading-xsmall",
        "heading-xxsmall",
        "body-large",
        "body",
        "body-small",
        "metric-large",
        "metric-medium",
      ],
    },
  },
});

export function mergeClassNames(...inputs: ClassValue[]) {
  return mergeTailwindClassNames(clsx(inputs));
}
